import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AuthContext } from '../../../legacyAuthContext';
import { usePersonalPurchase } from '../../../productRouting/personalPurchase';

// The personal plan card's button on the homepage and /pricing.
//
// After launch it opens Routora's paywall (through sign-up when needed). Before
// launch it keeps the previous website's checkout exactly as it was. That
// checkout is a Stripe Payment Link for the legacy annual plan; it is retired
// at launch, and its links are deactivated in Stripe as part of the cutover.
export default function usePersonalPlanAction() {
  const legacyAccount = useContext(AuthContext);
  const history = useHistory();
  const openRoutoraPurchase = usePersonalPurchase();

  return openRoutoraPurchase || (() => startLegacyPersonalCheckout(legacyAccount, history));
}

async function startLegacyPersonalCheckout(
  { currentUser, currentUserTier, checkSubStatus, updateUserTier, updateSubId },
  history
) {
  if (!currentUser) {
    history.push('/signup');
    return;
  }

  let subStatus = 'active';
  if (currentUserTier > 1) {
    try {
      subStatus = await checkSubStatus(currentUser);
      if (subStatus === 'canceled') {
        updateUserTier(currentUser, 0);
        updateSubId(currentUser, null);
      }
    } catch (error) {
    }
  }

  if (currentUserTier === 2 && subStatus !== 'canceled') {
    alert('You already have a PLUS subscription. Please cancel your subscription in the profile page before continuing.');
    return;
  }

  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      value: 173.99,
      pricing_plan: 'PLUS',
      is_yearly: true,
    });
  }

  const stripeCheckoutUrl = `https://buy.stripe.com/${process.env.REACT_APP_WEB_CHECKOUT}?prefilled_email=${encodeURIComponent(currentUser.email)}&client_reference_id=${currentUser.uid}`;
  window.location.href = stripeCheckoutUrl;
}
